import { render, staticRenderFns } from "./Soccer.vue?vue&type=template&id=cc5913d2&scoped=true&"
import script from "./Soccer.vue?vue&type=script&lang=js&"
export * from "./Soccer.vue?vue&type=script&lang=js&"
import style0 from "./Soccer.vue?vue&type=style&index=0&id=cc5913d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5913d2",
  null
  
)

export default component.exports